import userProfileComponent from './user_profile.component';

let userProfileModule = angular.module('userprofile', [])

  .component('userprofile', userProfileComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
			.state('app.userProfile', {
			url: '/user-profile',
				component: 'userprofile'
			});
	})

  .name;

export default userProfileModule;


// WEBPACK FOOTER //
// ./client/app/components/user_profile/index.js